<section class="bmc-tracing__section">

  <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
        <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'TRACE.VISUALIZATION' | translate | uppercase}}"
        (click)="viewerClicked()" [active]="viewerActive">
          <biz-trace-viewer *ngIf="!showTraceImprovement"></biz-trace-viewer>
          <biz-trace-viewer-management *ngIf="showTraceImprovement" class="trace-content"></biz-trace-viewer-management>
        </bzg-tab-item>
        <bzg-tab-item  *ngIf="showTraceImprovement" [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'TRACE.CONFIGURATION' | translate | uppercase}}"
        (click)="configClicked()" [active]="configActive">
                      <bz-loading [showLoading]="showLoading" [message]="'TRACE.LOADING_CONFIGURATION' | translate"></bz-loading>
            <biz-trace-node-list #traceNodeList class="bmc-tracing__section-list"></biz-trace-node-list>
            <div *ngIf="this.configActive" class="bmc-tracing__header">
              <bzg-button-primary  (click)="traceNodeList.save()">{{'GLOBAL.SAVE_ALL' | translate}}</bzg-button-primary>
            </div>
        </bzg-tab-item>
    </bzg-tab-set>
</section>

